/**
 * @generated SignedSource<<376faf19ea810ac32ba70cba255941cf>>
 * @relayHash 121892a3b61d556a2e78576c275f10d0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 71d5c32b862db5ace6218925d319ec3cc9bb57a8d4c0c8c4652fb23580cde973

import type { ConcreteRequest, Query } from 'relay-runtime';
export type SmartFieldsDropdownItemQuery$variables = {
  cloudId: string;
};
export type SmartFieldsDropdownItemQuery$data = {
  readonly jira: {
    readonly applicationPropertiesByKey: ReadonlyArray<{
      readonly key: string;
      readonly value: string;
    }> | null | undefined;
  } | null | undefined;
};
export type SmartFieldsDropdownItemQuery = {
  response: SmartFieldsDropdownItemQuery$data;
  variables: SmartFieldsDropdownItemQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  },
  {
    "kind": "Literal",
    "name": "keys",
    "value": [
      "jira.create.smart.fields.is-enabled"
    ]
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "key"
},
v3 = {
  "kind": "ScalarField",
  "name": "value"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "SmartFieldsDropdownItemQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "JiraApplicationProperty",
            "kind": "LinkedField",
            "name": "applicationPropertiesByKey",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/)
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SmartFieldsDropdownItemQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "JiraApplicationProperty",
            "kind": "LinkedField",
            "name": "applicationPropertiesByKey",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "kind": "ScalarField",
                "name": "id"
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "71d5c32b862db5ace6218925d319ec3cc9bb57a8d4c0c8c4652fb23580cde973",
    "metadata": {},
    "name": "SmartFieldsDropdownItemQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "0d94dcf035fdc054ae62a0136ae94e05";

export default node;
